import {Project} from "../api/Project";

export const videoRankerProject: Project = {
    id: 2,
    title: "Video Ranker - YT Videos",
    description: "This application is a productivity tool for YouTubers' to give them a feaure to know the rank of their videos on YouTube.",
    hidden: true,
    image: "https://lh3.googleusercontent.com/dr3PdSGtu0SsB-I_3uehfmf5UZGr08uFWXhBxp4it56XyvRgLviRTloK8bKJM0zBuA=s180-rw",
    link: "https://play.google.com/store/apps/details?id=in.outlook_com.chiragji.youtuberanker",
    startDate: "December 2017",
    completeDate: "January 2018",
    technologies: {
        frontend: undefined,
        backend: [
            "Android"
        ],
    },
};